// Это и есть '~shared/ui/integrations/Sanity'
// eslint-disable-next-line no-restricted-imports
import { PortableText as Native } from '@portabletext/react';
import { toMerged } from 'es-toolkit/object';
import type { PortableTextReactComponents } from 'next-sanity';
import { useMemo } from 'react';
import type { TypedObject } from 'sanity';

import { BlockLink } from './BlockLink';
import { customComponents } from './customComponents';

type Props = {
	value: unknown;
	components?: Partial<PortableTextReactComponents>;
};

export const PortableText = ({ value, components = {} }: Props) => {
	/*
		Делает deep merge дефолтных компонентов с переданными.
		Если нужно удалить какой-то дефолтный компонент, то нужно передать его как `null` в объекте `components`.
	*/
	const merged = toMerged(customComponents, components);
	return <Native components={merged} value={value as TypedObject} />;
};

export const PortableLinkText = ({
	value,
	onLinkClick,
}: {
	value: unknown;
	onLinkClick: (href?: string) => void;
}) => {
	const components = useMemo<Partial<PortableTextReactComponents>>(
		() => ({
			marks: {
				link: ({
					children,
					value,
				}: {
					children: React.ReactNode;
					value?: { href: string } & TypedObject;
				}) => (
					<BlockLink value={value} onClick={onLinkClick}>
						{children}
					</BlockLink>
				),
			},
		}),
		[onLinkClick]
	);
	return <PortableText value={value} components={components} />;
};
